import { observable, action } from "mobx";

class RouterStore {
  @observable currentPath: string = "";

  defaultPath: string = "/templates";

  constructor() {
    this.currentPath = this.pathOptions.TEMPLATES;
  }

  pathOptions = {
    TEMPLATES: "/templates",
    EDIT_TEMPLATE: "/templates/:id/edit",
    INTEGRATION_SETTING: "/integration/settings",
    INTEGRATION_PLUGINS: "/integration/plugins",
    INTEGRATION_PLUGIN: "/integration/plugins/:id/edit",
    INTEGRATION_PLUGIN_CF7: "/integration/plugins/cf7/edit",
    INTEGRATION_MAIL_PROVIDERS: "/integration/mail-providers",
    INTEGRATION_MAIL_PROVIDER: "/integration/mail-providers/:id/edit"
  };

  @action setRoute = (path: string) => {
    this.currentPath = path;
  };
}

export default RouterStore;
